/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_LabelInputs */

const vi_packaging_material_tracking_mode_label = /** @type {(inputs: Packaging_Material_Tracking_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chế độ tồn kho`)
};

/**

* @param {Packaging_Material_Tracking_Mode_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_label = /** @type {((inputs?: Packaging_Material_Tracking_Mode_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_label(inputs)
});